<vg-player>
    <video [vgMedia]="media" #media id="singleVideo" preload="auto" controls>
        <source [src]="src" type="video/mp4">
    </video>
</vg-player>